<template>
  <div class="subtitle">
    <div class="subtitle-title">
      <span class="titles" :class="[isFontMd ? 'fontLg' : 'fontLLG30', isPurple ? 'purple' : '', isRed ? 'red': '']" :style="{top: top ? top : '-21px'}"> {{title}} </span>
    </div>
    <div class="subtitle-discription">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "subtitle",
    props:['title', 'isFontMd', 'isPurple', 'top', 'isRed'],
    data() {
      return {

      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../style/color";
  .subtitle {
    @include content;

    &-title {
      margin-top: 30px;
      height: 35px;
      position: relative;
      border-top: 1px solid $c_000;
      border-left: 1px solid $c_000;
      border-right: 1px solid $c_000;
      .titles {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        background: $c_fff;
        padding: 0 39px;
        font-weight: bold;
        text-align: center;
        color: $c_000;
        &.top21 {
          top: -21px;
        }
        &.top15 {
          top: -15px;
        }
        &.fontLLG30 {
           font-size:  $font_llg30;
        }
        &.fontLg {
          font-size:  $font_lg;
        }
        &.purple {
          color: $c_915;
        }
        &.red {
          color: #ec1c24;
        }
      }

    }

    &-discription {
      @include borderLR(1px, $c_000);
      padding-bottom: 10px;
      &-text {
        width: 780px;
        margin:auto;
        // height: 25px;
        margin-bottom: 0px;
        text-align: center;
        color: $c_000;
        font-size: 16px;
        line-height: 24px;
        word-break: keep-all;
        word-wrap: break-word;
        font-family: "EperFontLight";
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/public/subtitle.vue